<template>
    <div>
        <oc-alert v-if="!hasPermission" :content="badPermissionsText" :closeButton="false" />

        <slot v-else></slot>
    </div>
</template>

<script>
import Vue from 'vue'
import Settings from '@/helpers/Settings'

export default {
    name: 'oc-access-control',
    provide() {
        let accessInfo = {}

        Object.defineProperty(accessInfo, 'permission', {
            enumerable: true,
            get: () => this.permission
        })

        Object.defineProperty(accessInfo, 'mode', {
            enumerable: true,
            get: () => this.mode
        })

        Object.defineProperty(accessInfo, 'isViewMode', {
            enumerable: true,
            get: () => inArray(this.mode, this.viewModes)
        })

        Object.defineProperty(accessInfo, 'isEditMode', {
            enumerable: true,
            get: () => inArray(this.mode, this.editModes)
        })

        return {
            // we provide object in order to have vue reactivity
            access: accessInfo
        }
    },
    props: {
        permission: {
            type: String
        },
        mode: {
            type: String
        },
        editModes: {
            type: [Array, String],
            default: () => {
                return Settings.get('editModes', [])
            }
        },
        viewModes: {
            type: [Array, String],
            default: () => {
                return Settings.get('viewModes', [])
            }
        },
        badPermissionsText: {
            type: String,
            default: 'You are not allowed to perform this action.'
        }
    },
    computed: {
        hasPermission() {
            if( this.permission ) {
                return this.$checkPermission(this.$_permission)
            }

            // if `permission` prop is empty we should display slot content
            return true
        },
        $_permission() {
            return this.permission + (this.mode ? '.' + this.mode : '')
        }
    }
}
</script>
